import { useTranslation } from "react-i18next";
import LegalContent from "./LegalContent";
import SEO from "../app/SEO";

export default function RecruitmentPolicy() {
    const { t } = useTranslation("legal");
    const sections: any[] = t("policies.recruitment.sections", { returnObjects: true });

    return (
        <>
        <SEO title={{ title: t("policies.recruitment.fullTitle"), pageTitle: t("policies.recruitment.fullTitle") }} canonicalPath="/legal/recruitment-policy" />
        <LegalContent
            title={t("policies.recruitment.title")}
            updated={t("lblUpdated", { date: t("policies.recruitment.updated") })}
            sections={sections} />
        </>
    );
}